import React, { useEffect } from 'react';
import { clearLegacyUserIdCookie } from '../services/api';
import { authSessionLog } from '../services/auth-session-logger';
import store from '../stores';
import { loggedOut } from '../stores/authenticated';
import { appEnv } from '../config/env';
import Repository from '../services/repository';

const Logout: React.FC = () => {
  useEffect(() => {
    document.title = `${appEnv.name} - ログアウト`;

    const run = async (): Promise<void> => {
      authSessionLog({
        level: 'info',
        event: 'hard_logout',
        reason: 'user',
        trigger: 'Logout.tsx',
      });
      try {
        await new Repository().logoutRemote();
      } catch {
        // オフラインや期限切れでもクライアント側は必ずクリーンアップする
      }
      clearLegacyUserIdCookie();
      store.dispatch(loggedOut());
      window.location.href = appEnv.dir;
    };

    void run();
  }, []);

  return null;
};

export default Logout;
